<template>
  <div>
    <el-button @click="visible=true" type="text">添加人员</el-button>
    <el-dialog title="添加人员" :visible.sync="visible" :before-close="handleClose" width="450px">
      <el-form
        ref="addPersonnel"
        :model="formData"
        size="medium"
        label-width="100px"
        label-position="left"
        :rules="rules"
      >
        <p class="title">人员信息</p>
        <el-form-item label="人员姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入人员姓名"></el-input>
        </el-form-item>
        <p class="title">账号信息</p>
        <el-form-item label="绑定手机号" prop="phone">
          <el-input v-model="formData.phone"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="code">
          <el-input style="width:150px" v-model="formData.code"></el-input>
          <el-button
            @click="sendCode"
            type="primary"
            :disabled="!show"
            :autofocus="!show"
            style="margin-left:10px;"
          >
            <span v-show="show">获取验证码</span>
            <span v-show="!show">{{count}} s</span>
          </el-button>
        </el-form-item> -->
      </el-form>
      <div class="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "add-dialog",
  data() {
    // var checkVerifyCode = (rules, val, callback) => {
    //   if (val === "") {
    //     callback(new Error("请输入验证码"));
    //   }
    //   callback();
    // };
    return {
      visible: false,
      formData: {
        phone: "",
        //code: "",
        name: ""
      },
      show: true,
      count: "",
      timer: null,
      rules: {
        phone: [{ required: true, message: "请输入绑定手机号" }],
        name: [{ required: true, message: "请输入人员姓名" }],
        // code: [{ validator: checkVerifyCode, message: "请输入验证码" }]
      }
    };
  },
  destroyed() {
    this.show = true;
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    handleClose() {
      this.$refs["addPersonnel"].resetFields();
      clearInterval(this.timer);
      this.show = true;
      this.timer = null;
      this.visible = false;
    },
    handleSubmit() {
      this.$refs["addPersonnel"].validate(val => {
        if (val) {
          this.save();
        }
      });
    },
    async save() {
      const { ret, data } = await _api.member.add(this.formData);
      if (ret && data) {
        this.$emit("success", data);
        this.$refs["addPersonnel"].resetFields();
        this.visible = false;
      }
    },
    async sendCode() {
      const {
        ret,
        data: { message }
      } = await _api.member.sendCode({
        phone: this.formData.phone
      });
      if (ret && message) {
        this.$message({
          type: "success",
          message: message
        });
        this.DealaySendCode();
      }
    },
    DealaySendCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style scoped>
.el-input {
  width: 300px;
}
.title {
  font-weight: 900;
  font-size: 18px;
}
</style>